// extracted by mini-css-extract-plugin
export default {"appear":"AppPageTransition_appear__3czO1","appearActive":"AppPageTransition_appearActive__4Nfp8"};